import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, MenuItem, Menu } from '@mui/material';
import { yellowMain } from '@ui/constants/color';
import { ArrowUp2, ArrowDown2 } from 'iconsax-react';
import { useEffect, useState } from 'react';
export const TextSelect = ({ options, onSelect, defaultOption, selectedOptions = null, color = 'yellow' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(selectedOptions);
    const [selectAnchorEl, setSelectAnchorEl] = useState(null);
    useEffect(() => {
        setSelectedOption(selectedOptions);
    }, [selectedOptions]);
    const handleClick = (event) => {
        setSelectAnchorEl(event.currentTarget);
        setIsOpen(true);
    };
    const handleMenuClose = (option) => {
        if (option) {
            setSelectedOption(option);
            if (onSelect) {
                onSelect(option);
            }
        }
        setSelectAnchorEl(null);
        setIsOpen(false);
    };
    return (_jsxs("div", { children: [_jsx(Box, { children: _jsx(Button, { variant: 'text', size: 'small', color: 'primary', onClick: handleClick, endIcon: isOpen ? _jsx(ArrowUp2, { size: '16px' }) : _jsx(ArrowDown2, { size: '16px' }), sx: {
                        justifyContent: 'space-between',
                        textTransform: 'capitalize',
                        fontSize: 14,
                        fontWeight: 500,
                        color: color === 'white' ? 'white' : yellowMain,
                        height: 'auto',
                    }, children: selectedOption || defaultOption || 'Select Option' }) }), _jsx(Menu, { open: isOpen, anchorEl: selectAnchorEl, onClose: () => handleMenuClose(), anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }, transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                }, PaperProps: {
                    sx: {
                        maxHeight: 300,
                        overflowY: 'auto'
                    }
                }, children: options.map((option) => (_jsx(MenuItem, { onClick: () => handleMenuClose(option.label), children: option.label }, option.value))) })] }));
};
